import { render, staticRenderFns } from "./StripeTermsAndConditions.vue?vue&type=template&id=f2d172f6&scoped=true&"
import script from "./StripeTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./StripeTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./StripeTermsAndConditions.vue?vue&type=style&index=0&id=f2d172f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d172f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2d172f6')) {
      api.createRecord('f2d172f6', component.options)
    } else {
      api.reload('f2d172f6', component.options)
    }
    module.hot.accept("./StripeTermsAndConditions.vue?vue&type=template&id=f2d172f6&scoped=true&", function () {
      api.rerender('f2d172f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StripeTermsAndConditions.vue"
export default component.exports